import React, { useState } from 'react';
import { loginUser } from '../../auth/authService';
import { useHistory, Link } from 'react-router-dom';
import { FiUser, FiLock } from 'react-icons/fi';
import { FaUser, FaLock, FaEye, FaEyeSlash, FaSpinner } from "react-icons/fa";

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await loginUser(username, password);
      history.push('/check-profile');
    } catch (err) {
      setError(err.message || 'Login failed');
    }
  };


  const [isHovered, setIsHovered] = useState(false);

  const baseStyles = {
    width: "100%",
    padding: "10px",
    marginTop: "15px",
    borderRadius: "8px",
    border: "1px solid #fff",
    background: loading
      ? "#fff"
      : isHovered
        ? "#A7F3D0" // light green on hover
        : "transparent",
    color: loading
      ? "#000"
      : isHovered
        ? "#000" // text turns black on hover
        : "#fff",
    fontWeight: "bold",
    cursor: loading ? "not-allowed" : "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-700 via-purple-700 to-pink-500 px-4">
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "30px",
          borderRadius: "16px",
          // background: "#2E2E2E",
          background: "#1e1e1e",
          boxShadow: "0 0 20px rgba(0,0,0,0.3)",
          textAlign: "center",
          transform: "scale(1)",
          animation: "fadeIn 1s ease",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "20px", // Space between image and text
          }}
        >

          <h5
            style={{
              fontWeight: "600",
              fontFamily: "monospace",
              color: "#fff",
              textTransform: "uppercase",
            }}
          >
            Welcome Back <span className="text-yellow-500">👋</span>
          </h5>
        </div>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="w-full">
          <div style={{ position: "relative", marginBottom: "15px" }}>

            {/* Username */}
            <FaUser
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#ccc",
              }}
            />
            <input
              type="text"
              placeholder="User Name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 10px 10px 40px",
                borderRadius: "8px",
                border: "1px solid #4c6793",
                background: "#2E2E2E",
                color: "#fff",
                outline: "none",
                transition: "border 0.3s ease",
              }}
            />
          </div>

          {/* Password */}
          <div style={{ position: "relative", marginBottom: "15px" }}>
            <FaLock
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#ccc",
              }}
            />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 10px 10px 40px",
                borderRadius: "8px",
                border: "1px solid #4c6793",
                background: "#2E2E2E",
                color: "#fff",
                outline: "none",
                transition: "border 0.3s ease",
              }}
            />
            <div
              onClick={() => setShowPassword((prev) => !prev)}
              style={{
                position: "absolute",
                top: "50%",
                right: "10px",
                transform: "translateY(-50%)",
                color: "#ccc",
                cursor: "pointer",
              }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={baseStyles}
          >
            {loading && (
              <FaSpinner style={{ animation: "spin 1s linear infinite" }} />
            )}
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        {/* Footer */}
        <div className="text-center mt-6 text-sm text-white">
          Don&apos;t have an account?{' '}
          <Link to="/signup" className="text-indigo-600 hover:underline font-medium">
            Sign up
          </Link>
        </div>
      </div >
    </div >
  );
};

export default LoginPage;
